module.exports = __webpack_public_path__ + "img/specialist-avatar.7e4a11bb.png";